<div class="grid-1col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="translatePrefix"></app-text-input>
    <app-text-input [form]="form" id="code" [prefix]="translatePrefix"></app-text-input>
    <app-select-input
        [form]="form"
        id="type"
        [prefix]="translatePrefix"
        [staticOptions]="accountingJournalTypeOptions"
        valueKey="value"
    ></app-select-input>
    <app-select-input
        [infiniteScroll]="store.accountScroll()"
        [form]="form"
        id="accountId"
        [prefix]="translatePrefix"
        valueKey="id"
        [autoDisplayFirst]="false"
    >
        <ng-template #item let-item>
            {{ item.code }} - {{ item.name }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ item.code }} - {{ item.name }}
        </ng-template>
    </app-select-input>

    <app-select-input
        [infiniteScroll]="store.currencyScroll()"
        [form]="form"
        id="currencyId"
        [prefix]="translatePrefix"
        valueKey="id"
        [autoDisplayFirst]="false"
    >
        <ng-template #item let-item>
            {{ item.code }} - {{ item.name }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ item.code }} - {{ item.name }}
        </ng-template>
    </app-select-input>

    <app-switch-input [form]="form" id="isDefault" [prefix]="translatePrefix"></app-switch-input>
</div>
